<mat-toolbar>
  <span>New Change Request </span>
</mat-toolbar>
<mat-divider></mat-divider>

<div class="container">
  <div class="center-section">
    <router-outlet></router-outlet>
  </div>
</div>
